import { useEffect } from "react";
import { Link } from "react-router-dom";
import "@/App.css";

export default function TermsPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="legal-page" data-testid="terms-page">
      <div className="legal-header">
        <Link to="/" className="legal-back" data-testid="terms-back-link">&larr; Back to Pacely</Link>
      </div>

      <h1 className="legal-title">Terms of Service</h1>
      <p className="legal-updated">Last updated: March 18, 2026</p>

      <div className="legal-content">
        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing or using the Pacely website ("Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.</p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>Pacely is an upcoming AI-powered running route generation platform currently in pre-launch. The Service currently provides a waitlist signup, customer discovery survey, and informational content about the upcoming product.</p>
        </section>

        <section>
          <h2>3. Waitlist &amp; Early Access</h2>
          <p>By joining the Pacely waitlist, you are expressing interest in the product. Joining the waitlist does not guarantee access to the final product, nor does it constitute a purchase or binding agreement. We may contact you via the email address you provide with updates about Pacely's development and launch.</p>
        </section>

        <section>
          <h2>4. Survey Participation</h2>
          <p>Participation in our customer discovery survey is voluntary. By completing the survey, you grant Pacely permission to use your anonymized responses for product development and research purposes. Your individual responses will not be shared publicly without your explicit consent.</p>
        </section>

        <section>
          <h2>5. User Conduct</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Submit false or misleading information</li>
            <li>Attempt to access restricted areas of the Service</li>
            <li>Use the Service for any unlawful purpose</li>
            <li>Interfere with or disrupt the Service's functionality</li>
          </ul>
        </section>

        <section>
          <h2>6. Intellectual Property</h2>
          <p>All content, branding, logos, and design elements on the Pacely website are the property of Pacely and are protected by intellectual property laws. You may not reproduce, distribute, or create derivative works from any content on this site without prior written consent.</p>
        </section>

        <section>
          <h2>7. Disclaimer</h2>
          <p>The Service is provided "as is" without warranties of any kind, either express or implied. Pacely does not warrant that the Service will be uninterrupted, error-free, or secure. As a pre-launch product, features and availability are subject to change.</p>
        </section>

        <section>
          <h2>8. Limitation of Liability</h2>
          <p>To the maximum extent permitted by law, Pacely shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service.</p>
        </section>

        <section>
          <h2>9. Changes to Terms</h2>
          <p>We reserve the right to modify these terms at any time. Changes will be posted on this page with an updated revision date. Your continued use of the Service after changes constitutes acceptance of the updated terms.</p>
        </section>

        <section>
          <h2>10. Contact</h2>
          <p>If you have questions about these Terms of Service, please reach out to us at <strong>pacely.tech@gmail.com</strong>.</p>
        </section>
      </div>

      <div className="legal-footer">
        <p>&copy; 2026 Pacely. All rights reserved.</p>
        <div className="legal-footer-links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/">Home</Link>
        </div>
      </div>
    </div>
  );
}
